<template>
  <!-- Table Container Card -->
  <div style="height: inherit">
    <b-card id="page-promotions" no-body class="mb-0 p-2">
      <b-card-header class="pl-0 pr-0">
        <b-card-title>
          <h2>{{ $t(label("title")) }}</h2>
        </b-card-title>

        <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
          <b-col
            cols="12"
            class="d-flex align-items-between justify-content-end"
          >
            <b-button id="tooltip-create" variant="primary" @click="onCreate">
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span class="text-nowrap">{{ $t(label("register")) }}</span>
            </b-button>
          </b-col>
        </b-col>

        <b-col
          v-if="canCreate"
          cols="12"
          sm="12"
          md="8"
          class="d-md-none d-flex justify-content-end align-items-center pt-2"
        >
          <b-button
            id="tooltip-create"
            variant="primary"
            @click="onCreate"
            class="btn-icon"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </b-col>

        <b-tooltip
          placement="top"
          target="tooltip-create"
          triggers="hover"
          @click="onInfo"
        >
          <strong>
            <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
            Ver tutorial
          </strong>
          <span> </span>
        </b-tooltip>
      </b-card-header>

      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />
      <!-- Table for larger devices -->
      <b-table
        id="promotions-table"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="d-none d-md-table shadow-sm !rounded"
      >
        <!-- A custom formatted header cell for field 'name' -->
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(startDate)="data">
          {{ dateFormat(data.item.startDate) }}
        </template>

        <template #cell(endDate)="data">
          {{ dateFormat(data.item.endDate) }}
        </template>

        <template #cell(active)="data">
          <div class="d-flex align-items-center">
            <b-badge pill :variant="tagsColor(data.item.active)">
              <span>{{ data.item.active ? "Activo" : "Inactivo" }}</span>
            </b-badge>
          </div>
        </template>

        <template #cell(actions)="data">
          <feather-icon
            v-if="canShow"
            class="text-success mr-25"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.idPromotion)"
          />

          <feather-icon
            v-if="canEdit"
            class="text-primary mr-25"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.idPromotion)"
          />

          <feather-icon
            v-if="canDelete"
            class="text-danger"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.idPromotion)"
          />
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>
      <!-- List for mobile devices -->
      <div id="list-container" class="d-block d-md-none mt-1 list-container">
        <b-list-group>
          <b-list-group-item
            v-for="item in items"
            :key="item.idPromotion"
            class="flex-column align-items-start border border-primary rounded mb-1"
          >
            <div class="d-flex w-100 justify-content-between m-0 p-0">
              <p style="margin-bottom: 0 !important">
                <strong> {{ item.name }}</strong>
              </p>

              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item
                  v-if="canShow"
                  @click="onShow(item.idPromotion)"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("show") }}
                    <feather-icon
                      class="text-success mr-25"
                      size="18"
                      icon="FileTextIcon"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canEdit"
                  @click="onEdit(item.idPromotion)"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("edit") }}
                    <feather-icon
                      class="text-primary mr-25"
                      size="18"
                      icon="EditIcon"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canDelete"
                  @click="onDelete(item.idPromotion)"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("delete") }}
                    <feather-icon
                      class="text-danger"
                      size="18"
                      icon="Trash2Icon"
                    />
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <!-- <br /> -->
            {{ $t(labelHeader("startdate")) }} :
            {{ dateFormat(item.startDate) }}
            <br />
            {{ $t(labelHeader("enddate")) }} : {{ dateFormat(item.endDate) }}
            <br />
            <b-badge pill :variant="tagsColor(item.active)">
              <span>{{ item.active ? "Activo" : "Inactivo" }}</span>
            </b-badge>
          </b-list-group-item>
          <b-list-group-item v-if="items.length == 0" class="text-center">
            {{ $t("notRegister") }}
          </b-list-group-item>
          <b-list-group-item v-if="loading" class="text-center">
            <b-spinner variant="success"></b-spinner>
          </b-list-group-item>
        </b-list-group>
      </div>
      <!-- pagination -->
      <div class="mx-2 d-none d-md-table">
        <b-row>
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">{{
                $t("perPage")
              }}</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                @change="handlePerPageChange"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="10"
            lg="10"
            xl="10"
            class="d-flex align-items-center justify-content-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              @change="handlePageChange"
              first-number
              last-number
            >
              <template #prev-text>
                <feather-icon size="18" icon="ChevronLeftIcon" />
              </template>
              <template #next-text>
                <feather-icon size="18" icon="ChevronRightIcon" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import {
  allPromotionsByCompany,
  deletePromotion,
} from "@core/api/request/promotions";
import { allCompanies } from "@core/api/request/company";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BAvatar,
    vSelect,
    Filterss,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "promotions",
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    companies: [],
    companyGuid: null,
    fields: [
      { label: "name", key: "name", sortable: true },
      // { label: "company", key: "nameCompany", sortable: false },
      { label: "description", key: "description", sortable: false },
      { label: "startDate", key: "startDate", sortable: false },
      { label: "endDate", key: "endDate", sortable: false },
      { label: "active", key: "active", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
    name: null,
    filtersOn: false,
    hasNextPage: true,
    name: null,
  }),

  computed: {
    canCreate() {
      return canAccess("Promociones", "creation");
    },
    canShow() {
      return canAccess("Promociones", "reading");
    },
    canEdit() {
      return canAccess("Promociones", "edition");
    },
    canDelete() {
      return canAccess("Promociones", "elimination");
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.loadPromotions();
    },
  },

  mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadPromotions();
    document
      .getElementById("list-container")
      .addEventListener("scroll", this.handleScroll);
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();

        // Usamos Promise.all para cargar productos y catálogos en paralelo
        const [promotionResp] = await Promise.all([allProducts(params)]);

        // Procesamos productos
        const promotions = _.get(promotionResp, "data");
        this.items = promotions?.items || [];
        this.totalRows = promotions?.totalRows || 0;
        this.hasNextPage =
          promotions?.currentPage < promotions?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },

    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadPromotionsInfinity();
      }
    },
    label(field) {
      return `pages.promotions.table.${field}`;
    },

    dateFormat(fechaISO) {
      const fecha = new Date(fechaISO);
      const dia = String(fecha.getDate()).padStart(2, "0");
      const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Los meses empiezan desde 0
      const anio = fecha.getFullYear();
      return `${dia}-${mes}-${anio}`;
    },

    labelHeader(field) {
      return `pages.promotions.table.tableHeader.${field}`;
    },

    tagsColor(stock) {
      if (stock > 0) return "light-success";
      else return "light-danger";
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.name != null) arrParams.push(`name,${this.name}`);
      arrParams.push(`active,${true}`);
      return getParams(arrParams);
    },

    chargeParamsWhitFilters(name, category) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`active,${true}`);
      if (name != null) arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },

    loadPromotions() {
      // if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      allPromotionsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    async loadServicesInfinity() {
      if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      await allPromotionsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          // this.items = data?.items || [];
          this.items = [...this.items, ...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
          this.loading = !this.loading;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadPromotionsWithFIlters(name) {
      if (!this.hasNextPage) return;
      const param = this.chargeParamsWhitFilters(name);
      this.loading = !this.loading;
      allPromotionsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
          console.log("reps", resp);
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadPromotions();
    },

    handlePerPageChange() {
      this.loadPromotions();
    },
    applyFilters(filters) {
      this.appliedFilters = filters;
      this.name = filters.name;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadPromotionsWithFIlters(
        filters.name == null ? null : filters.name,
      );
    },
    resetFilters() {
      this.appliedFilters = {};
      this.name = null;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadPromotions();
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "promotionCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },
    onShow(id) {
      if (!this.canShow) return;
      this.$router.push({
        name: "promotionEdit",
        params: {
          option: 2, // option 2 to show
          idPromotion: id,
        },
      });
    },

    onEdit(id) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "promotionEdit",
        params: {
          option: 3, // option 3 to edit
          idPromotion: id,
        },
      });
    },

    onDelete(id) {
      if (!this.canDelete) return;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deletePromotion(id)
            .then(() => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                console.log("Alert result", result);
                if (result.isConfirmed) {
                  this.loadPromotions();
                } else if (result.isDenied) {
                  console.log("Denied!");
                }
              });
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", this.$t("codeAlert"), error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    onInfo() {},

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
